import {
  RevertEmailChangeRequest,
  RevertEmailChangeResponse,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type RevertEmailChangeOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  token: string;
  password: string;
};

export const revertEmailChange = async <TFunctions>(
  options: RevertEmailChangeOptions<TFunctions>,
): Promise<RevertEmailChangeResponse> => {
  const { functions, httpsCallable, token, password } = options;
  const callable = httpsCallable<
    RevertEmailChangeRequest,
    RevertEmailChangeResponse
  >(functions, 'users-revertEmailChange');

  return (await callable({ token, password })).data;
};
